import React, { useState, useMemo } from "react";
import {
  Tabs,
  Row,
  Col,
  Form,
  Input,
  Badge,
  Select,
  Modal,
  Button,
  Space,
} from "antd";
import {
  SearchOutlined,
  FilterOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import styled from "@emotion/styled";
import UITable from "../../../src/Reusablecomponents/UITable/UITable.js";
import FilterIcon from "../../../src/assets/images/Filter-Icon.svg";
import InsurancePage from "../../../src/containers/Workshop/InsurancePage.js";
import { Navigate, useNavigate } from "react-router-dom";

const { Option } = Select;
const PageWrapper = styled.div`
  padding: 24px;
  background: #fff;
`;

const ContainerOneVehicle = styled.div`
  .containerone {
    display: flex;
    justify-content: space-between;
    padding: 9px 5px 9px 5px;
    align-items: center;
  }
  .containerone_two {
    display: flex;
    gap: 20px;
  }
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-tab {
    font-size: 14px;
    color: #595959;
    padding: 10px 20px;
  }

  .ant-tabs-tab.ant-tabs-tab-active {
    background: #f6fffa;
    border-radius: 6px 6px 0 0;

    .ant-tabs-tab-btn {
      color: #389e6e;
      font-weight: 500;
    }
  }

  .ant-tabs-ink-bar {
    background: #389e6e;
  }

  .ant-tabs-nav {
    margin-bottom: 20px;
  }

  .ant-tabs-tab:hover:not(.ant-tabs-tab-active) .ant-tabs-tab-btn {
    color: #262626;
  }
`;

const VehicleCount = styled.span`
  font-size: 14px;
  color: #595959;
`;

const RightTools = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 20px;
  padding: 6px 14px;
  background: #fff;
  width: 260px;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: #389e6e;
  }

  input {
    border: none;
    outline: none;
    font-size: 13px;
    color: #595959;
    width: 100%;
    background: transparent;

    &::placeholder {
      color: #bfbfbf;
    }
  }

  .anticon {
    color: #bfbfbf;
    font-size: 15px;
    flex-shrink: 0;
  }

  @media (max-width: 576px) {
    width: 160px;
  }
`;

const FilterBtn = styled.div`
  position: relative;
  width: 36px;
  height: 36px;
  border: 1px solid #e8e8e8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fff;
  color: #595959;
  transition: border-color 0.2s;

  &:hover {
    border-color: #389e6e;
    color: #389e6e;
  }

  .anticon {
    font-size: 16px;
  }
`;

const LastServiceCell = styled.div`
  .km {
    font-size: 13px;
    color: #595959;
  }
  .dt {
    font-size: 12px;
    color: #bfbfbf;
    margin-top: 2px;
  }
`;

const KmsText = styled.span`
  font-size: 13px;
  font-weight: ${({ $warn, $over }) => ($warn || $over ? "500" : "400")};
  color: ${({ $over, $warn }) =>
    $over ? "#cf1322" : $warn ? "#d48806" : "#595959"};
`;

const StatusText = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ $status }) =>
    $status === "OK"
      ? "#389e6e"
      : $status === "Due Soon"
        ? "#d48806"
        : "#cf1322"};
`;

// ─── Data ─────────────────────────────────────────────────────────────────────

const VEHICLES = [
  {
    key: 1,
    no: "KA1234532",
    driver: "John Doe",
    type: "Truck",
    odo: 73400,
    lastKms: 68500,
    lastDate: "12-01-2025",
    remaining: 2300,
    status: "Due Soon",
  },
  {
    key: 2,
    no: "KA1234532",
    driver: "John Doe",
    type: "Truck",
    odo: 73400,
    lastKms: 68500,
    lastDate: "12-01-2025",
    remaining: 2300,
    status: "OK",
  },
  {
    key: 3,
    no: "KA1234532",
    driver: "John Doe",
    type: "Truck",
    odo: 73400,
    lastKms: 68500,
    lastDate: "12-01-2025",
    remaining: 2300,
    status: "OK",
  },
  {
    key: 4,
    no: "KA1234532",
    driver: "John Doe",
    type: "Truck",
    odo: 73400,
    lastKms: 68500,
    lastDate: "12-01-2025",
    remaining: -2300,
    status: "Overdue",
  },
  {
    key: 5,
    no: "KA1234532",
    driver: "John Doe",
    type: "Truck",
    odo: 73400,
    lastKms: 68500,
    lastDate: "12-01-2025",
    remaining: 2300,
    status: "OK",
  },
  {
    key: 6,
    no: "KA1234533",
    driver: "Alice Smith",
    type: "Van",
    odo: 45200,
    lastKms: 40000,
    lastDate: "10-03-2025",
    remaining: 4800,
    status: "OK",
  },
  {
    key: 7,
    no: "KA1234534",
    driver: "Bob Kumar",
    type: "Truck",
    odo: 88900,
    lastKms: 83000,
    lastDate: "05-02-2025",
    remaining: -1500,
    status: "Overdue",
  },
  {
    key: 8,
    no: "KA1234535",
    driver: "Priya Nair",
    type: "SUV",
    odo: 33100,
    lastKms: 28500,
    lastDate: "20-04-2025",
    remaining: 5400,
    status: "OK",
  },
];

const COLUMNS = [
  {
    title: "Vehicle No",
    dataIndex: "no",
    key: "no",
    render: (val) => (
      <span style={{ color: "#262626", fontSize: 13 }}>{val}</span>
    ),
  },
  {
    title: "Driver",
    dataIndex: "driver",
    key: "driver",
    render: (val) => (
      <span style={{ color: "#262626", fontSize: 13 }}>{val}</span>
    ),
  },
  {
    title: "Vehicle Type",
    dataIndex: "type",
    key: "type",
    responsive: ["md"],
  },
  {
    title: "Current ODO",
    dataIndex: "odo",
    key: "odo",
    responsive: ["md"],
    render: (val) => val.toLocaleString(),
  },
  {
    title: "Last Service",
    key: "lastService",
    render: (_, row) => (
      <LastServiceCell>
        <div className="km">{row.lastKms.toLocaleString()} Kms</div>
        <div className="dt">{row.lastDate}</div>
      </LastServiceCell>
    ),
  },
  {
    title: "KMS Remaining",
    dataIndex: "remaining",
    key: "remaining",
    render: (val) => (
      <KmsText $over={val < 0} $warn={val >= 0 && val < 2500}>
        {val.toLocaleString()}
      </KmsText>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (val) => <StatusText $status={val}>{val}</StatusText>,
  },
];

const FILTER_CYCLE = ["all", "Overdue", "Due Soon", "OK"];

const Workshop = () => {
  const [form] = Form.useForm();
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("service");
  const [filterIdx, setFilterIdx] = useState(0);
  const [openFilter, setOpenFilter] = useState(false);

  const filterMode = FILTER_CYCLE[filterIdx];
  const navigate = useNavigate();

  const TABS = [
    { key: "service", label: "Service", component: "" },
    {
      key: "insurance",
      label: "Insurance",
    },
    {
      key: "inspection",
      label: "Inspection",
    },
    { key: "speedGovernor", label: "Speed Governor" },
  ];

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return VEHICLES.filter((v) => {
      const matchSearch =
        !q ||
        v.no.toLowerCase().includes(q) ||
        v.driver.toLowerCase().includes(q) ||
        v.type.toLowerCase().includes(q);
      const matchFilter = filterMode === "all" || v.status === filterMode;
      return matchSearch && matchFilter;
    });
  }, [search, filterMode]);

  const filterBadge =
    filterMode === "all"
      ? 3
      : filterMode === "Overdue"
        ? "!"
        : filterMode === "Due Soon"
          ? "~"
          : "✓";

  const handleChangetabs = (value) => {
    console.log(value, "value");
    const selectedTab = TABS.find((item) => item.key === value);
    console.log(selectedTab?.key, "selectedTabselectedTab");

    setActiveTab(selectedTab?.key);
  };

  console.log(activeTab, "activeTaba");
  const BookButton = styled(Button)`
    background: #22c55e;
    border-color: #22c55e;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    border-radius: 6px;

    &:hover,
    &:focus {
      background: #16a34a !important;
      border-color: #16a34a !important;
      color: #fff !important;
    }
  `;

  const StatusText = styled.span`
    color: ${({ status }) => (status === "Overdue" ? "#ef4444" : "#22c55e")};
    font-weight: 500;
  `;

  const DaysText = styled.span`
    color: ${({ overdue }) => (overdue ? "#ef4444" : "#22c55e")};
    font-weight: 500;
  `;
  const DATA = [
    {
      key: "1",
      vehicle: "KA1234532",
      driver: "John Doe",
      type: "Truck",
      last: "20th Jan 2025",
      days: 88,
      next: "20th Feb 2025",
      status: "Up to date",
    },
    {
      key: "2",
      vehicle: "KA5678901",
      driver: "Ravi Kumar",
      type: "Truck",
      last: "20th Jan 2025",
      days: 88,
      next: "20th Feb 2025",
      status: "Up to date",
      showBook: true,
    },
    {
      key: "3",
      vehicle: "KA9012345",
      driver: "Arjun Singh",
      type: "Van",
      last: "20th Jan 2025",
      days: -12,
      next: "20th Feb 2025",
      status: "Overdue",
    },
    {
      key: "4",
      vehicle: "KA3456789",
      driver: "Meena Pillai",
      type: "Van",
      last: "20th Jan 2025",
      days: -12,
      next: "20th Feb 2025",
      status: "Overdue",
    },
    {
      key: "5",
      vehicle: "KA7890123",
      driver: "Suresh Babu",
      type: "Truck",
      last: "15th Feb 2025",
      days: 45,
      next: "15th Mar 2025",
      status: "Up to date",
    },
    {
      key: "6",
      vehicle: "KA2345678",
      driver: "Priya Nair",
      type: "Bus",
      last: "10th Mar 2025",
      days: 72,
      next: "10th Apr 2025",
      status: "Up to date",
    },
  ];
  const columns = [
    {
      title: "Vehicle No",
      dataIndex: "vehicle",
      key: "vehicle",
      render: (val) => (
        <span style={{ color: "#111827", fontWeight: 500 }}>{val}</span>
      ),
    },
    {
      title: "Driver",
      dataIndex: "driver",
      key: "driver",
    },
    {
      title: "Vehicle Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Last Inspection",
      dataIndex: "last",
      key: "last",
    },
    {
      title: "Days Remaining",
      dataIndex: "days",
      key: "days",
      render: (val) => <DaysText overdue={val < 0 ? 1 : 0}>{val}</DaysText>,
    },
    {
      title: "Next Due",
      dataIndex: "next",
      key: "next",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (val, record) =>
        record.showBook ? (
          <Space>
            <StatusText status={val}>{val}</StatusText>
            <BookButton size="small">Book</BookButton>
          </Space>
        ) : (
          <StatusText status={val}>{val}</StatusText>
        ),
    },
    {
      title: "",
      key: "action",
      render: () => (
        <Button type="text" size="small" style={{ color: "#9ca3af" }}>
          ⋮
        </Button>
      ),
    },
  ];

  const columnsz = [
    {
      title: "Vehicle No",
      dataIndex: "vehicleNo",
      key: "vehicleNo",
      render: (text) => <span style={{ color: "#5f6d8c" }}>{text}</span>,
    },
    {
      title: "Driver",
      dataIndex: "driver",
      key: "driver",
      render: (text) => <span style={{ color: "#5f6d8c" }}>{text}</span>,
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicleType",
      key: "vehicleType",
      render: (text) => <span style={{ color: "#5f6d8c" }}>{text}</span>,
    },
    {
      title: "Installed On",
      dataIndex: "installedOn",
      key: "installedOn",
      render: (text) => <span style={{ color: "#5f6d8c" }}>{text}</span>,
    },
    {
      title: "Last Calibrated",
      dataIndex: "lastCalibrated",
      key: "lastCalibrated",
      render: (text) => <span style={{ color: "#5f6d8c" }}>{text}</span>,
    },
    {
      title: "Certificate",
      dataIndex: "certificate",
      key: "certificate",
      render: (_, record) => (
        <a
          href={`/certificates/${record.key}`}
          style={{ color: "#5f6d8c", textDecoration: "underline" }}
          onClick={(e) => {
            e.preventDefault();
            console.log("Viewing certificate for row:", record.key);
          }}
        >
          View
        </a>
      ),
    },
  ];

  const dataSourcez = [
    {
      key: "1",
      vehicleNo: "KA1234532",
      driver: "John Doe",
      vehicleType: "Truck",
      installedOn: "20th Jan 2025",
      lastCalibrated: "20th Jan 2025",
    },
    {
      key: "2",
      vehicleNo: "KA1234532",
      driver: "John Doe",
      vehicleType: "Truck",
      installedOn: "20th Jan 2025",
      lastCalibrated: "20th Jan 2025",
    },
    {
      key: "3",
      vehicleNo: "KA1234532",
      driver: "John Doe",
      vehicleType: "Truck",
      installedOn: "20th Jan 2025",
      lastCalibrated: "20th Jan 2025",
    },
    {
      key: "4",
      vehicleNo: "KA1234532",
      driver: "John Doe",
      vehicleType: "Truck",
      installedOn: "20th Jan 2025",
      lastCalibrated: "20th Jan 2025",
    },
  ];

  return (
    <>
      <Modal
        open={openFilter}
        footer={null}
        closable={false}
        width={1400}
        centered
        onCancel={() => setOpenFilter(false)}
        styles={{
          body: {
            padding: 0,
            borderRadius: "20px",
            overflow: "hidden",
          },
        }}
      >
        {/* HEADER */}
        <div
          style={{
            padding: "24px",
            borderBottom: "1px solid #f0f0f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: 20,
              fontWeight: 600,
            }}
          >
            Filter (12)
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 30,
            }}
          >
            <div
              style={{
                color: "#2f9e44",
                fontSize: 18,
                fontWeight: 500,
              }}
            >
              4 Results found
            </div>

            <CloseOutlined
              onClick={() => setOpenFilter(false)}
              style={{
                fontSize: 24,
                cursor: "pointer",
              }}
            />
          </div>
        </div>

        {/* BODY */}
        <div style={{ padding: "30px" }}>
          <Row gutter={[30, 30]}>
            <Col span={6}>
              <div>Status</div>

              <Select
                style={{ width: "100%", marginTop: 10 }}
                size="large"
                defaultValue="Due Soon"
              >
                <Option value="Due Soon">Due Soon</Option>
              </Select>
            </Col>

            <Col span={6}>
              <div>Vehicle Type</div>

              <Select
                style={{ width: "100%", marginTop: 10 }}
                size="large"
                defaultValue="Truck"
              >
                <Option value="Truck">Truck</Option>
              </Select>
            </Col>

            <Col span={6}>
              <div>Vehicle No</div>

              <Select
                style={{ width: "100%", marginTop: 10 }}
                size="large"
                defaultValue="KAA 123A"
              >
                <Option value="KAA 123A">KAA 123A</Option>
              </Select>
            </Col>

            <Col span={6}>
              <div>Driver</div>

              <Select
                style={{ width: "100%", marginTop: 10 }}
                size="large"
                defaultValue="Tony"
              >
                <Option value="Tony">Tony</Option>
              </Select>
            </Col>

            <Col span={6}>
              <div>Last Serviced</div>

              <Select
                style={{ width: "100%", marginTop: 10 }}
                size="large"
                defaultValue="01-04-2025"
              >
                <Option value="01-04-2025">01-04-2025</Option>
              </Select>
            </Col>
          </Row>

          {/* CLEAR BUTTON */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 60,
            }}
          >
            <button
              style={{
                background: "#2f9e44",
                color: "#fff",
                border: "none",
                borderRadius: 30,
                padding: "12px 40px",
                fontSize: 20,
                cursor: "pointer",
              }}
            >
              Clear All
            </button>
          </div>
        </div>
      </Modal>
      <PageWrapper>
        <StyledTabs
          activeKey={activeTab}
          onChange={handleChangetabs}
          items={TABS}
        />

        <Form form={form} layout="vertical">
          <ContainerOneVehicle>
            <div className="containerone">
              <div>
                <VehicleCount>{filtered.length} Vehicles</VehicleCount>
              </div>
              <div className="containerone_two">
                <Form.Item name="search" noStyle>
                  <SearchBox>
                    <SearchOutlined />
                    <input
                      placeholder="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </SearchBox>
                </Form.Item>
                <Badge count={filterBadge} size="small" color="#ff4d4f">
                  <img
                    onClick={() => setOpenFilter(true)}
                    src={FilterIcon}
                    title="Export Icon"
                    alt="Export Icon"
                    width={20}
                  />
                </Badge>
              </div>
            </div>
          </ContainerOneVehicle>
        </Form>
        {activeTab === "service" ? (
          <UITable
            dataSource={filtered}
            columns={COLUMNS}
            rowKey="key"
            pagination={{ pageSize: 10, size: "small" }}
            scroll={{ x: "max-content" }}
            onRow={(record) => ({
              onClick: () => {
                console.log(record);

                navigate("/ServiceDetails", {
                  state: record,
                });
              },
            })}
          />
        ) : null}
      </PageWrapper>
      {activeTab === "inspection" ? (
        <UITable
          columns={columns}
          dataSource={DATA}
          pagination={false}
          rowKey="key"
          onRow={(record) => ({
            onClick: () => {
              console.log(record);

              navigate("/ServiceDashboard", {
                state: record,
              });
            },
          })}
        />
      ) : null}
      {activeTab === "insurance" ? (
        <InsurancePage activeTab={activeTab} />
      ) : null}

      {activeTab === "speedGovernor" ? (
        <div style={{ padding: "20px", background: "#ffffff" }}>
          <UITable
            columns={columnsz}
            dataSource={dataSourcez}
            pagination={false}
            onRow={(record) => ({
              onClick: () => {
                console.log(record);

                navigate("/SpeedGovernorDashboard", {
                  state: record,
                });
              },
            })}
          />
        </div>
      ) : null}
    </>
  );
};

export default Workshop;
